import { colors } from '../../colors';
var richText = {
  backgroundColor: colors.white,
  h1Color: colors.nvaBlack,
  h2Color: colors.nvaBlack,
  paraColor: colors.nvaBlack,
  anchorColor: colors.nvaTeal
};
export default richText;